import { ActionType } from "../../../../../../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../../../../../../react-core/Flux/BaseStore";
import { CommonHelper } from "../../../../../../../../react-core/Helpers/CommonHelper";
import { SubAccountType } from "../../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { Money } from "../../../../../../../../Wrap/Core/DataTypes/Money";
import { AssetClassInstrumentWeighting } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/AssetClassInstrumentWeighting";
import { Investment } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/Investment";
import { InvestmentsDispatcher, ModelUnderlyingInvestmentsDispatcher } from "./Variable";

export interface InvestmentsStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    data?: IInvestmentTableData;
}

export interface ITotal {
    Difference: Money;
    Allocation: number;
    TotalCost: Money;
    MarketValue: Money;
    InstrumentWeight: number;
}

export interface IInvestmentTableData {
    total: ITotal; // total
    data: IProductTableData[];
}

export interface IHoldingsData {
    data: IInvestmentGroup[];
    total: ITotal;
}

export interface IInvestmentGroup {
    AssetClass?: string;
    Investments?: Array<IInvestmentWithToggle>;
    total: ITotal;
}

export interface IInvestmentWithToggle extends Investment {
    isToggle?: boolean;
    sub?: IInvestmentGroup[];
    InstrumentWeighting: number;
}

export interface IProductTableData {
    ClAccountId?: string;
    WrapperType?: SubAccountType;
    ProductDisplayName?: string;
    ModelPortfolioInvestments?: IHoldingsData;
    OffPlatformInvestments?: IHoldingsData;
    InstrumentWeighting?: Array<AssetClassInstrumentWeighting>;
    IndividualInvestments: IHoldingsData;
    RingfencedInstruments: string[];
    TreasuredAssets: number[];
    EditTreasureAssets: number[];
    total: ITotal; // product total
}

export interface IModelInvestment {
    instrumentCode: string;
    index: number;
    product: number;
    underlyings: IInvestmentGroup[];
}
export interface IModelUnderlyingInvestmentData {
    investments: Map<string, IModelInvestment>;
    isLoading: boolean;
    actionType: ActionType;
}

export class ModelUnderlyingInvestmentsStatic extends BaseStore<IModelUnderlyingInvestmentData> {
    constructor() {
        super();
        this.subscribeToDispatcher(ModelUnderlyingInvestmentsDispatcher, (data) =>
            this.onModelUnderlyingInvestmentsStoreResponse(data)
        );
    }

    onModelUnderlyingInvestmentsStoreResponse(data): void {
        switch (data.actionType) {
            case ActionType.Success:
                if (data.payload && !CommonHelper.isNullOrEmpty(data.payload.instrumentCode)) {
                    const { investments } = this.getState();
                    investments.set(data.payload.instrumentCode, data.payload);
                    this.setState({ investments: investments, isLoading: false, actionType: ActionType.Success });
                }
        }
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }
    public getActionType() {
        return this.getState().actionType;
    }
    public getData() {
        return this.getState().investments;
    }
    public resetData() {
        return this.resetState();
    }
    protected getDefaultState(): IModelUnderlyingInvestmentData {
        return {
            investments: new Map<string, IModelInvestment>(),
            isLoading: true,
            actionType: ActionType.Loading,
        };
    }
}

export class InvestmentsStatic extends BaseStore<InvestmentsStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(InvestmentsDispatcher, (actionData) => this.onInvestmentsStoreResponse(actionData));
    }

    public getLastResult(): InvestmentsStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getData() {
        return this.getState().data;
    }

    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): InvestmentsStaticState {
        return { actionType: ActionType.Loading, data: null };
    }

    private onInvestmentsStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ actionType: actionData.actionType, data: actionData.payload });
                break;
            case ActionType.Error:
                this.setState({ actionType: actionData.actionType });
                break;
            case ActionType.Loading:
                this.setState({ actionType: actionData.actionType });
                break;
        }
    }
}
